import React, { useState } from "react";
import "./UserModal.css";
import { $host } from "../../../../http";
import AssignCourse from "./utils/AssignCourse";
import CreateSubscribe from "./utils/CreateSubscribe";
import EditUserModal from "./utils/EditUserModal";
import ResetPasswordModal from "./utils/ResetPasswordModal";

const UserModal = ({ user, onClose }) => {
    const [showAssignCourse, setShowAssignCourse] = useState(false);
    const [showPurchasedCourses, setShowPurchasedCourses] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    const [showResetPassword, setShowResetPassword] = useState(false);
    const [availableCourses, setAvailableCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [userSubscriptions, setUserSubscriptions] = useState(user.subscriptions || []);

    // Определение типа регистрации (Email или Telegram)
    const registrationType = user.telegram_id ? "Telegram" : "Email";

    const fetchAvailableCourses = async () => {
        try {
            const { data } = await $host.get("/api/public/courses");
            setAvailableCourses(data);
            setShowAssignCourse(true);
        } catch (error) {
            console.error("Ошибка при загрузке доступных курсов:", error);
        }
    };
    const handleSubscriptionCreated = async () => {
        try {
            const { data } = await $host.get(`/api/admin/users/${user.id}`); // 🔥 Берём подписки из API
            setUserSubscriptions(data.subscriptions || []); // ✅ Обновляем список подписок с сервера
        } catch (error) {
            console.error("Ошибка при обновлении подписок пользователя:", error);
        }
    };



    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close" onClick={onClose}>✖</button>
                <h2 className="modal-header">{user.first_name || "Без имени"} {user.last_name || ""}</h2>

                <div className="user-info">
                    <div className="info-item">
                        <span className="info-label">ID:</span>
                        <span className="info-value">{user.id}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Тип регистрации:</span>
                        <span className="info-value">{registrationType}</span>
                    </div>
                    {user.telegram_id ? (
                        <div className="info-item">
                            <span className="info-label">Telegram ID:</span>
                            <span className="info-value">{user.telegram_id}</span>
                        </div>
                    ) : (
                        <div className="info-item">
                            <span className="info-label">Email:</span>
                            <span className="info-value">{user.email || "Не указан"}</span>
                        </div>
                    )}
                    <div className="info-item">
                        <span className="info-label">Роль:</span>
                        <span className="info-value">{user.role}</span>
                    </div>
                    <div className="info-item">
                        <span className="info-label">Дата регистрации:</span>
                        <span className="info-value">{new Date(user.created_at).toLocaleDateString()}</span>
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="modal-button" onClick={() => setShowPurchasedCourses(true)}>
                        Купленные курсы
                    </button>
                    <button className="modal-button" onClick={fetchAvailableCourses}>
                        Назначить курс
                    </button>
                    <button className="modal-button" onClick={() => setShowEditUser(true)}>
                        Редактировать пользователя
                    </button>
                    <button className="modal-button" onClick={() => setShowResetPassword(true)}>
                        Сбросить пароль
                    </button>
                </div>
            </div>

            {showPurchasedCourses && (
                <AssignCourse user={user} onClose={() => setShowPurchasedCourses(false)} />
            )}

            {showAssignCourse && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <button className="modal-close" onClick={() => setShowAssignCourse(false)}>✖</button>
                        <h3 className="modal-header">Выберите курс</h3>
                        {availableCourses.length > 0 ? (
                            <ul className="courses-list">
                                {availableCourses.map((course) => (
                                    <li key={course.id} className="course-item">
                                        <span className="course-title">{course.title}</span>
                                        <button className="modal-button" onClick={() => setSelectedCourse(course)}>
                                            Назначить
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>Нет доступных курсов</p>
                        )}
                    </div>
                </div>
            )}

            {selectedCourse && (
                <CreateSubscribe
                    user={user}
                    course={selectedCourse}
                    onClose={() => setSelectedCourse(null)}
                    onSubscriptionCreated={handleSubscriptionCreated} // ✅ Теперь передаём пропс!
                />
            )}


            {showEditUser && (
                <EditUserModal user={user} onClose={() => setShowEditUser(false)} />
            )}

            {showResetPassword && (
                <ResetPasswordModal user={user} onClose={() => setShowResetPassword(false)} />
            )}
        </div>
    );
};

export default UserModal;
